/* Lunar Bass: swipe between product card images on touch screens. Binds each card on first touch, no page wide observers. */
(function () {
  if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
  var SEL = '.card-product__media-secondary-image .product-link';
  function bind(link) {
    if (link.dataset.lbSwipe) return;
    link.dataset.lbSwipe = '1';
    link.querySelectorAll('.product-secondary-image img, .product-third-image img').forEach(function (img) {
      if (img.loading === 'lazy') img.loading = 'eager';
    });
    var dots = link.parentElement ? link.parentElement.querySelector('.lb-card-dots') : null;
    var spans = dots ? dots.querySelectorAll('span') : [];
    if (!spans.length) return;
    var timer;
    link.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(link.scrollLeft / Math.max(link.clientWidth, 1));
        spans.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      }, 50);
    }, { passive: true });
  }
  document.addEventListener('touchstart', function (e) {
    var link = e.target.closest && e.target.closest(SEL);
    if (link) bind(link);
  }, { passive: true, capture: true });
})();
